import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getSkillsV2 } from '@/common/services/SkillsService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, type GroupOptionsBase } from '@/common/types/cacheConstants'

interface GroupOptions extends GroupOptionsBase {
  includeDeactivated?: boolean
}

function groupOptions(options: GroupOptions = {}) {
  const { includeDeactivated = true, ...config } = options
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SKILLS,
      params: {
        'include-deactivated': includeDeactivated,
      },
    }),
    staleTime: Infinity,
    queryFn: () => {
      return getSkillsV2(includeDeactivated)
    },
  }
  return queryOptions(merge(defaultConfig, config))
}

async function fetch(options: GroupOptions = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(groupOptions(options)),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.SKILLS,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SKILLS,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
